import React from "react";

const Title = () => {
  return (
    <div className="my-12">
      <h2 className="mb-5 text-[35px] font-semibold text-primary">
        Request testnet LINK
      </h2>
      <p className="w-full md:w-[680px] text-gray">
        Get testnet LINK for an account on one of the supported blockchain
        testnets so you can create and test your own oracle and Chainlinked
        smart contract
      </p>
    </div>
  );
};

export default Title;
